"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _apis = require("../../../../@apis");
var _i18n = require("../../../../@i18n");
var _hooks = require("../../../../@hooks");
var _functions = require("../../../../@functions");
var _store = require("../../../../@api/store");
var _collectame = require("../../../../@api/collectame");
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _InboxRequest = _interopRequireDefault(require("../../../../@custom/InboxRequest"));
var _Spinner = _interopRequireDefault(require("../../../Spinner"));
var _CertificadoAtivo = _interopRequireDefault(require("../../../../@assets/images/Certificado Ativo.svg"));
var _CertificadoInativo = _interopRequireDefault(require("../../../../@assets/images/Certificado Inativo.svg"));
var _FavoritoAtivo = _interopRequireDefault(require("../../../../@assets/images/Favorito Ativo.png"));
var _FavoritoInativo = _interopRequireDefault(require("../../../../@assets/images/Favorito Inativo.png"));
var _LixeiraAtiva = _interopRequireDefault(require("../../../../@assets/images/Lixeira Ativa.png"));
var _LixeiraInativa = _interopRequireDefault(require("../../../../@assets/images/Lixeira Inativa.png"));
var _EXCLAMAÇÃO = _interopRequireDefault(require("../../../../@assets/images/EXCLAMA\xC7\xC3O.svg"));
var _RestaurarAtivo = _interopRequireDefault(require("../../../../@assets/images/Restaurar Ativo.svg"));
var _RestaurarInativo = _interopRequireDefault(require("../../../../@assets/images/Restaurar Inativo.svg"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef AccountPageProps
 * @type {import("../../index").AccountPageProps}
 */

var storage = _collectame.firebase.storage();

/** @param {AccountPageProps} props */
function Certificates(props) {
  var auth = props.auth;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var chosenSolution = localStorage.getItem('chosen-solution');
  var _useState3 = (0, _react.useState)(chosenSolution === 'taugor-certificates' || chosenSolution === 'taugor-cloud-certificates'),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    cloudCertificatesEnabled = _useState4[0],
    setCloudCertificatesEnabled = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    certificates = _useState6[0],
    setCertificates = _useState6[1];

  /** @param {React.ChangeEvent<HTMLInputElement>} evt */
  var handleToggleCloudCertificates = function handleToggleCloudCertificates(evt) {
    var checked = evt.target.checked;
    setCloudCertificatesEnabled(checked);
    localStorage.setItem('chosen-solution', checked ? 'taugor-certificates' : 'lacuna');
  };

  /** @param {File} file */
  var uploadCertificate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(file) {
      var fullName, phone, document, user, newCertificate;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fullName = "".concat(auth.user.firstName, " ").concat(auth.user.lastName).trim();
            phone = (0, _functions.onlyNumbers)("".concat(auth.user.phoneCountry).concat(auth.user.phoneArea).concat(auth.user.phone));
            document = (0, _functions.onlyNumbers)(auth.user.taxDocument);
            user = {
              name: fullName,
              email: auth.user.email,
              document: document,
              phone: phone,
              birthdate: auth.user.birthdate
            };
            _context.prev = 4;
            _context.next = 7;
            return _apis.signatureMsApi.certificates.upload(file, storage, {
              metadata: {
                user: user
              }
            });
          case 7:
            newCertificate = _context.sent;
            setCertificates(function (prev) {
              return [].concat((0, _toConsumableArray2["default"])(prev), [newCertificate]);
            });
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            _store.services.message.show('Não foi possível enviar o certificado', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
              error: _context.t0,
              additionalInfo: {
                user: user
              }
            }));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11]]);
    }));
    return function uploadCertificate(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUploadCertificate = function handleUploadCertificate() {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = '.pfx';
    input.multiple = false;
    input.onchange = function () {
      var files = Array.from(input.files || []);
      if (files.length === 0) return;
      uploadCertificate(files[0]);
    };
    input.click();
  };
  var handleToggleFavorite = function handleToggleFavorite(certificate) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var willBeFavorite, currentFavorite, promises;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            willBeFavorite = !certificate.metadata.favorite;
            currentFavorite = certificates.find(function (cert) {
              return cert.metadata.favorite;
            });
            setCertificates(function (prev) {
              return prev.map(function (cert) {
                if (cert.uid === certificate.uid) {
                  cert.metadata.favorite = willBeFavorite;
                }
                if (cert.uid === (currentFavorite === null || currentFavorite === void 0 ? void 0 : currentFavorite.uid) && willBeFavorite) {
                  cert.metadata.favorite = false;
                }
                return _objectSpread({}, cert);
              });
            });
            promises = [];
            promises.push(_apis.signatureMsApi.certificates.update(certificate.uid, {
              'metadata.favorite': willBeFavorite
            }));
            if (willBeFavorite && currentFavorite) {
              promises.push(_apis.signatureMsApi.certificates.update(currentFavorite.uid, {
                'metadata.favorite': false
              }));
            }
            _context2.next = 8;
            return Promise.all(promises);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  };
  var handleToggleDeletion = function handleToggleDeletion(certificate) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var deleted;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            deleted = !certificate.deleted;
            setCertificates(function (prev) {
              return prev.map(function (cert) {
                if (cert.uid === certificate.uid) {
                  cert.deleted = deleted;
                  cert.metadata.favorite = false;
                }
                return _objectSpread({}, cert);
              });
            });
            _context3.next = 4;
            return _apis.signatureMsApi.certificates.update(certificate.uid, {
              deleted: deleted,
              'metadata.favorite': false
            });
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  var handleValidateCertificate = function handleValidateCertificate(certificate) {
    return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var password, promise;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            password = '';
            if (password) {
              _context5.next = 7;
              break;
            }
            promise = new Promise( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(resolve) {
                return _regenerator["default"].wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _store.services.message.show('Digite a sua senha para validar seu certificado', /*#__PURE__*/_react["default"].createElement(PasswordModal, {
                        onChange: function onChange(value) {
                          return password = value;
                        },
                        value: password
                      }), [{
                        save: true,
                        onClick: function onClick() {
                          _store.services.message.hide();
                          resolve(password);
                        },
                        text: 'Enviar'
                      }]);
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x2) {
                return _ref5.apply(this, arguments);
              };
            }());
            _context5.next = 6;
            return promise;
          case 6:
            password = _context5.sent;
          case 7:
            setLoading(true);
            _context5.next = 10;
            return _apis.signatureMsApi.certificates.validate({
              uid: certificate.uid,
              url: certificate.url
            }, password);
          case 10:
            _context5.next = 12;
            return fetchCloudCertificates();
          case 12:
            _context5.next = 17;
            break;
          case 14:
            _context5.prev = 14;
            _context5.t0 = _context5["catch"](0);
            _store.services.message.show('Não foi possível validar o certificado', /*#__PURE__*/_react["default"].createElement(_InboxRequest["default"], {
              error: _context5.t0,
              additionalInfo: {
                certificate: certificate
              }
            }));
          case 17:
            _context5.prev = 17;
            setLoading(false);
            return _context5.finish(17);
          case 20:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 14, 17, 20]]);
    }));
  };
  var fetchCloudCertificates = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
      var taxDocument, promise, certificates;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            taxDocument = auth.user.taxDocument;
            if (taxDocument) {
              _context8.next = 6;
              break;
            }
            promise = new Promise( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(resolve) {
                var handleSaveTaxDocument;
                return _regenerator["default"].wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      handleSaveTaxDocument = /*#__PURE__*/function () {
                        var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                          return _regenerator["default"].wrap(function _callee6$(_context6) {
                            while (1) switch (_context6.prev = _context6.next) {
                              case 0:
                                _store.services.message.hide();
                                _context6.next = 3;
                                return _apis.appcenterApi.company.users.save(auth.company.uid, _objectSpread(_objectSpread({}, auth.user), {}, {
                                  taxDocument: taxDocument
                                }));
                              case 3:
                                resolve(taxDocument);
                              case 4:
                              case "end":
                                return _context6.stop();
                            }
                          }, _callee6);
                        }));
                        return function handleSaveTaxDocument() {
                          return _ref8.apply(this, arguments);
                        };
                      }();
                      _store.services.message.show('Digite o seu documento de identificação para encontrar seus certificados', /*#__PURE__*/_react["default"].createElement(TaxDocumentModal, {
                        onChange: function onChange(value) {
                          return taxDocument = value;
                        },
                        value: taxDocument
                      }), [{
                        save: true,
                        onClick: handleSaveTaxDocument,
                        text: 'Atualizar'
                      }]);
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              return function (_x3) {
                return _ref7.apply(this, arguments);
              };
            }());
            _context8.next = 5;
            return promise;
          case 5:
            taxDocument = _context8.sent;
          case 6:
            setLoading(true);
            _context8.next = 9;
            return _apis.signatureMsApi.certificates.list({
              'metadata.user.document': "==".concat((0, _functions.onlyNumbers)(taxDocument))
            });
          case 9:
            certificates = _context8.sent;
            setCertificates(certificates);
            setLoading(false);
          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function fetchCloudCertificates() {
      return _ref6.apply(this, arguments);
    };
  }();
  var sortCertificates = function sortCertificates(a, b) {
    if (a.deleted) return 1;
    if (b.deleted) return -1;
    return 0;
  };
  (0, _react.useEffect)(function () {
    fetchCloudCertificates();
  }, []);
  (0, _hooks.useAsyncEffect)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var favoriteExpiredCertificates, promises;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          favoriteExpiredCertificates = certificates.filter(function (certificate) {
            var today = new Date();
            var expirationDate = (0, _functions.toDate)(certificate.validity.notAfter);
            var isExpired = today.getTime() > expirationDate.getTime();
            return isExpired;
          }).filter(function (certificate) {
            return certificate.metadata.favorite;
          });
          promises = favoriteExpiredCertificates.map(function (certificate) {
            return _apis.signatureMsApi.certificates.update(certificate.uid, {
              'metadata.favorite': false
            });
          });
          _context9.next = 4;
          return Promise.all(promises);
        case 4:
          if (!(favoriteExpiredCertificates.length > 0)) {
            _context9.next = 7;
            break;
          }
          _context9.next = 7;
          return fetchCloudCertificates();
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  })), [certificates]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-certificates",
    "data-fullwidth": true,
    "data-fullheight": true
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: "Account-certificates-header"
  }, /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    className: "Account-certificates-uploadNewCertificate",
    onClick: handleUploadCertificate
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Account-certificates-uploadNewCertificate-icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faPlus"
  })), /*#__PURE__*/_react["default"].createElement("span", null, "Carregar novo certificado")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-certificates-enableCloudCertificates"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-certificates-taugorWebPkiDescription",
    "data-selected": !cloudCertificatesEnabled
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Usar Taugor PKI"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "50% + caro \u2022 90% + lento \u2022 Precisa de plugin \u2022 N\xE3o salva o certificado")), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react["default"].createElement(_material.Switch, {
      onChange: handleToggleCloudCertificates,
      checked: cloudCertificatesEnabled
    })
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-certificates-cloudCertificatesDescription",
    "data-selected": cloudCertificatesEnabled
  }, /*#__PURE__*/_react["default"].createElement("strong", null, "Usar Certificados em Nuvem"), " ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", null, "50% + barato \u2022 90% + r\xE1pido")))), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "Account-certificates-list"
  }, loading ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
    className: "Account-certificates-loading"
  }) : certificates.sort(sortCertificates).map(function (certificate) {
    return /*#__PURE__*/_react["default"].createElement(CertificateCard, {
      certificate: certificate,
      handleToggleDeletion: handleToggleDeletion(certificate),
      handleToggleFavorite: handleToggleFavorite(certificate),
      handleValidate: handleValidateCertificate(certificate)
    });
  })));
}
var _default = Certificates;
/**
 * @param {{
 *     onChange: (value: string) => void;
 *     value: string;
 * }} props
 */
exports["default"] = _default;
function TaxDocumentModal(_ref10) {
  var onChange = _ref10.onChange,
    value = _ref10.value;
  var _useState7 = (0, _react.useState)('cpf'),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    documentType = _useState8[0],
    setDocumentType = _useState8[1];
  var _useState9 = (0, _react.useState)(value),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    document = _useState10[0],
    setDocument = _useState10[1];
  var mask = documentType === 'cpf' ? '999.999.999-99' : documentType === 'cnpj' ? '99.999.999/9999-99' : undefined;
  (0, _react.useEffect)(function () {
    onChange(document);
  }, [document]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.FormControl, null, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, "Tipo do documento"), /*#__PURE__*/_react["default"].createElement(_material.RadioGroup, {
    row: true,
    onChange: function onChange(evt) {
      return setDocumentType(evt.target.value);
    },
    value: documentType
  }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "cpf",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: "CPF"
  }), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "cnpj",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: "CNPJ"
  }), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    value: "other",
    control: /*#__PURE__*/_react["default"].createElement(_material.Radio, null),
    label: "Outro"
  }))), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    alwaysShowMask: true,
    label: "Documento de Identifica\xE7\xE3o",
    onChange: function onChange(evt) {
      return setDocument(evt.target.value);
    },
    value: document,
    mask: mask
  }));
}

/**
 * @param {{
 *     onChange: (value: string) => void;
 *     value: string;
 * }} props
 */
function PasswordModal(_ref11) {
  var onChange = _ref11.onChange,
    value = _ref11.value;
  var _useState11 = (0, _react.useState)(value),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    password = _useState12[0],
    setPassword = _useState12[1];
  (0, _react.useEffect)(function () {
    onChange(password);
  }, [password]);
  return /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Senha",
    type: "password",
    onChange: function onChange(evt) {
      return setPassword(evt.target.value);
    },
    value: password
  });
}

/**
 * @param {{
 *     certificate: any;
 *     handleToggleDeletion: () => void;
 *     handleToggleFavorite: () => void;
 *     handleValidate: () => void;
 * }} props
 */
function CertificateCard(_ref12) {
  var _certificate$issuer;
  var certificate = _ref12.certificate,
    handleToggleDeletion = _ref12.handleToggleDeletion,
    handleToggleFavorite = _ref12.handleToggleFavorite,
    handleValidate = _ref12.handleValidate;
  var isDecrypted = !!certificate.decrypted;
  var today = new Date();
  var expirationDate = (0, _functions.toDate)(certificate.validity.notAfter);
  var isExpired = isDecrypted && expirationDate instanceof Date && today.getTime() > expirationDate.getTime();
  var isFavorite = !!certificate.metadata.favorite;
  var isDeleted = !!certificate.deleted;
  var disabled = isExpired || !isDecrypted;
  var favoritateIcon = disabled || !isFavorite || isDeleted ? _FavoritoInativo["default"] : _FavoritoAtivo["default"];
  var deleteIcon = '';
  if (disabled) {
    deleteIcon = isDeleted ? _RestaurarInativo["default"] : _LixeiraInativa["default"];
  } else {
    deleteIcon = isDeleted ? _RestaurarAtivo["default"] : _LixeiraAtiva["default"];
  }
  var certificateIcon = isExpired ? _CertificadoInativo["default"] : !isDecrypted ? _EXCLAMAÇÃO["default"] : _CertificadoAtivo["default"];
  return /*#__PURE__*/_react["default"].createElement("li", {
    key: certificate.uid,
    className: "Account-certificates-card",
    "data-favorited": isFavorite,
    "data-expired": isExpired,
    "data-deleted": isDeleted,
    "data-decrypted": isDecrypted,
    "data-disabled": disabled
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "Account-certificates-card-certificateImage",
    src: certificateIcon,
    alt: "\xCDcone de certificado"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-certificates-card-info"
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: "Account-certificates-card-name"
  }, certificate.name || certificate.filename, " / "), /*#__PURE__*/_react["default"].createElement("span", {
    className: "Account-certificates-card-description"
  }, ' ', certificate.decrypted ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ((_certificate$issuer = certificate.issuer) === null || _certificate$issuer === void 0 ? void 0 : _certificate$issuer.commonName) && "Emitido por ".concat(certificate.issuer.commonName)) : 'Certificado não validado')), certificate.decrypted && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-certificates-card-separator"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "Account-certificates-card-info"
  }, /*#__PURE__*/_react["default"].createElement("strong", {
    className: "Account-certificates-card-field"
  }, "Data de validade"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "Account-certificates-card-value"
  }, ' ', _i18n.format.date(expirationDate), isExpired && ' (EXPIRADO)'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "Account-certificates-card-actions"
  }, certificate.decrypted ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: isDeleted ? 'Restaurar' : 'Deletar'
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    className: "Account-certificates-card-action",
    onClick: handleToggleDeletion,
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: deleteIcon,
    alt: "Apagar"
  }))), /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    title: isFavorite ? 'Desfavoritar' : 'Favoritar'
  }, /*#__PURE__*/_react["default"].createElement(_material.IconButton, {
    className: "Account-certificates-card-action",
    onClick: handleToggleFavorite,
    disabled: disabled || isDeleted
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: favoritateIcon,
    alt: "Favoritar"
  })))) : /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    onClick: handleValidate
  }, "Validar")));
}